import React from "react";
import useFitText from "use-fit-text";

export default ({ children }) => {
  const { fontSize, ref } = useFitText({
    maxFontSize: 200,
  });
  return (
    <div
      style={{
        paddingTop: "5vh",
        paddingBottom: "5vh",
        height: "20vh",
      }}
    >
      <h2 style={{ height: "15vh", width: "100%", fontSize }} ref={ref}>
        {children}
      </h2>
    </div>
  );
};
